export default function toPhoneNumFormat(value: string | null) {
	if (!value || !isFinite(+value)) {
		return '';
	}

	// 지역번호와 나머지 번호로 나누기
	if (value.startsWith('02')) {
		if (value.length <= 2) {
			return value;
		} else if (value.length <= 5) {
			return value.replace(/^(\d{0,2})(\d{0,3})$/, '$1-$2');
		} else if (value.length <= 8) {
			return value.replace(/^(\d{0,2})(\d{0,3})(\d{0,3})$/, '$1-$2-$3');
		} else if (value.length <= 9) {
			return value.replace(/^(\d{0,2})(\d{0,3})(\d{0,4})$/, '$1-$2-$3');
		} else if (value.length <= 10) {
			return value.replace(/^(\d{0,2})(\d{0,4})(\d{0,4})$/, '$1-$2-$3');
		} else {
			return value;
		}
	} else {
		if (value.length <= 3) {
			return value;
		} else if (value.length <= 6) {
			return value.replace(/^(\d{0,3})(\d{0,3})$/, '$1-$2');
		} else if (value.length <= 9) {
			return value.replace(/^(\d{0,3})(\d{0,3})(\d{0,3})$/, '$1-$2-$3');
		} else if (value.length <= 10) {
			return value.replace(/^(\d{0,3})(\d{0,3})(\d{0,4})$/, '$1-$2-$3');
		} else if (value.length <= 11) {
			return value.replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/, '$1-$2-$3');
		} else {
			return value;
		}
	}
}
